import { render, staticRenderFns } from "./ComparisonTable.vue?vue&type=template&id=d5c4d3d0&scoped=true&"
import script from "./ComparisonTable.vue?vue&type=script&lang=js&"
export * from "./ComparisonTable.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonTable.vue?vue&type=style&index=0&id=d5c4d3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c4d3d0",
  null
  
)

export default component.exports